import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { Picture } from 'ui-kit/picture'
import { DOCS_LINK } from 'routes/constants'
import { BookCalendlyLink } from 'routes/components/Shared'
import Icon from './sparkles.svg'
import ImageMob1x from './image-mob1x.png'
import ImageMob2x from './image-mob2x.png'
import ImageDesk1x from './image-desk1x.png'
import ImageDesk2x from './image-desk2x.png'
import classes from './UniversalConnectorsHero.module.scss'

export const UniversalConnectorsHero = () => {
  return (
    <Block
      as={'section'}
      pad={'baseMob'}
      variant={'shadowMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <hgroup className={classes.title_wrap}>
        <Text
          as={'span'}
          size={'sm'}
          lh={'relaxed'}
          className={classes.title__label}
        >
          <img
            src={Icon.src}
            width={16}
            height={16}
            aria-hidden='true'
            alt=''
          />
          Powered by Al
        </Text>
        <Heading
          as={'h1'}
          size={'xxl'}
          center
          balance
          className={classes.title}
        >
          Universal Connectors
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Build deep integrations with any app without delving into its API.
        </Text>
      </hgroup>
      <div className={classes.actions}>
        {/* <Link type='secondary' href={'#'}>
          Watch a 2-minute explanation
        </Link> */}
        <Link
          type='secondary'
          asPageButton
          href={`${DOCS_LINK}/connector-builder`}
          target='_blank'
        >
          Read the docs
        </Link>
        <Text as={'span'} size={'lg'} className={classes.actions_text}>
          or
        </Text>
        <BookCalendlyLink type={'primary'} className={classes.button}>
          Book a demo
        </BookCalendlyLink>
      </div>

      <div className={classes.visual}>
        <Picture
          mobSrc1x={ImageMob1x.src}
          mobSrc2x={ImageMob2x.src}
          deskSrc1x={ImageDesk1x.src}
          deskSrc2x={ImageDesk2x.src}
          className={classes.image}
          alt='Universal Resources'
          width={350}
          height={777}
          fetchPriorityHigh
        />
      </div>
    </Block>
  )
}
